import { useEffect } from 'react';
import { ResponsiveValues, useResponsiveValue } from './use-responsive-value';

const DEFAULT_OFFSET: ResponsiveValues<number> = {
  base: -71,
  xl: -81,
};

export const useListenStickyElement = (
  ref:
    | ((instance: HTMLDivElement | null) => void)
    | React.RefObject<HTMLDivElement | null>,
  onStickyChange: (value: boolean) => void,
  options?: {
    offset?: ResponsiveValues<number>;
  }
) => {
  const offsetValue = useResponsiveValue(options?.offset ?? DEFAULT_OFFSET);
  useEffect(() => {
    if (typeof ref != 'object' || ref.current == null) return;

    const stickyElm = ref.current;
    const observer = new IntersectionObserver(
      ([e]) => {
        if (e == null) return;
        onStickyChange?.(e.intersectionRatio < 1);
      },
      {
        threshold: [1],
        rootMargin: `${offsetValue}px 0px 0px 0px`,
      }
    );

    observer.observe(stickyElm);
    return () => {
      observer.unobserve(stickyElm);
    };
  }, [offsetValue]);
};
